import React from 'react';

const Footer = props => (
    <footer
        className="site-contentinfo site-contentinfo--interior slds-grid slds-grid_vertical-align-center slds-order_3 slds-m-top_medium"
        role="contentinfo"
    >
        <div className="slds-col">
            <nav>
                <ul className="slds-list_horizontal slds-has-dividers_right slds-has-block-links slds-wrap">
                    <li className="slds-item">
                        <a href="https://www.salesforce.com/company/legal/sfdc-website-terms-of-service.jsp">
                            Terms of Service
                        </a>
                    </li>
                    <li className="slds-item">
                        <a href="https://www.salesforce.com/company/privacy/">
                            Privacy
                        </a>
                    </li>
                    <li className="slds-item">
                        <a href="https://www.salesforce.com/company/disclosure/">
                            Responsible Disclosure
                        </a>
                    </li>
                    <li className="slds-item">
                        <a href="https://trust.salesforce.com/" target="_blank">
                            Trust
                        </a>
                    </li>
                </ul>
            </nav>
            <p>
                © Copyright 2015-present Salesforce.com, inc.{' '}
                <a href="https://www.salesforce.com/company/legal/intellectual/">
                    All rights reserved
                </a>
                . Various trademarks held by their respective owners.
            </p>
            <p>
                Salesforce, Inc. Salesforce Tower, 415 Mission Street, 3rd Floor, San Francisco, CA 94105, United States
            </p>
        </div>
    </footer>
);
module.exports = Footer;



// WEBPACK FOOTER //
// ./public/src/components/footer.jsx